import { LucideIcon } from 'lucide-react-native';
import { StyleSheet, View } from 'react-native';

import { colors, spacing } from '@/constants/theme';

import { Button } from './Button';
import { Card } from './Card';
import { Heading } from './Heading';
import { Text } from './Text';

export type EmptyStateProps = {
  title: string;
  body?: string;
  icon?: LucideIcon;
  cta?: { label: string; onPress: () => void };
  /** Render without a Card wrapper for inline placement. */
  bare?: boolean;
  testID?: string;
};

export function EmptyState({
  title,
  body,
  icon: Icon,
  cta,
  bare = false,
  testID,
}: EmptyStateProps) {
  const inner = (
    <>
      {Icon && <Icon size={32} color={colors.textMuted} strokeWidth={1.75} />}
      <Heading size="2xl" style={styles.title}>
        {title}
      </Heading>
      {body && (
        <Text variant="caption" color="textMuted" align="center" style={styles.body}>
          {body}
        </Text>
      )}
      {cta && (
        <Button label={cta.label} variant="outline" size="sm" onPress={cta.onPress} />
      )}
    </>
  );

  if (bare) {
    return (
      <View style={styles.container} testID={testID}>
        {inner}
      </View>
    );
  }

  return (
    <Card style={styles.container} testID={testID}>
      {inner}
    </Card>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    paddingVertical: spacing.xl,
    gap: spacing.sm,
  },
  title: {
    textAlign: 'center',
  },
  body: {
    maxWidth: 280,
  },
});
